import React, { Component } from 'react';
import "./Landscape.scss"

class Landscape extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        return (
            <section className="section section-helpers-landscape">
                <div className="padding">
                    <div className="container">
                        <div className="landscape-msg">
                            לחווית הגלישה הטובה ביותר יש להשאיר את המכשיר במצב Portrait
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Landscape;



// WEBPACK FOOTER //
// ./src/Components/Helpers/Landscape/Landscape.jsx